<!-- Login Form -->
<div id="loginBox" style="display: block;">
    <form class="loginForm" id="loginForm" name="loginForm" (ngSubmit)="f.form.valid && loginClicked()" #f="ngForm">
        <img src="assets/images/EF_logo-login.png" alt="">
        <hr />
        <input type="text" id="userIdField" name="userIdField" class="form-control input-lg" placeholder="Username" [(ngModel)]="mUserId" required />
        <input type="password" id="passwordField" name="passwordField" class="form-control input-lg" placeholder="Password" [(ngModel)]="mPassword" />
        <button id="loginButton" class="btn btn-lg btn-ef btn-block" type="submit" [disabled]="mLoading"><i class="fa fa-sign-in" aria-hidden="true"></i> SIGN IN</button><br>
        <button type="button" class="btn btn-link btn-xs" style="text-decoration: underline;" [disabled]="mLoading" (click)="forgotUsernamePasswordClicked()">Forgot Username/Password</button>
    </form>
</div>

<!-- Login Error Message Popup -->
<div id="passwordResetPopup" [class.show]="mDisplayErrorPopup">{{mError}}</div>

<!-- Forgot Usernam/Password Dialog Popup -->
<app-forgot-username-password-dialog #forgotUsernamePasswordDialog (resetEvent)="sendPasswordResetEmail($event)"></app-forgot-username-password-dialog>

<!-- Simple Error Dialog Box -->
<ef-simple-success-error-dialog-box #successErrorDialog></ef-simple-success-error-dialog-box>